<template>
  <div>
    <Modal v-model="showModal" :closable="false" :mask-closable="false" >
        <p slot="header"></p>
        <div style="text-align:center;">
          <p v-show="!journalName" style="padding:10px">移动端投稿功能暂未上线，投稿请在PC端完成
            <span style="word-wrap:break-word;">{{http}}</span>
            <b class="link" @click="copy()">复制链接</b></p>
          <p v-show="journalName">{{`《${journalName}》尚未开通中文知识网融合出版服务平台。如果您是作者想给本刊投稿或查询进度，请与编辑部直接联系！`}}</p>
        </div>
        <div slot="footer" >
            <Button @click="$emit('closeModal')">关闭</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: ['showModal','journalName'],
  data() {
    return {
      http:''
    }
  },
  created(){
    let cardInfo = JSON.parse(sessionStorage.getItem('cardInfo'))
    if (!cardInfo) return
    let path = location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1 ?'https://cbtest.cnknowledge.com/':''
    this.http = path+'?editId='+cardInfo.userId+'&perId='+cardInfo.perId
  },
  methods: {
    copy() {
      let transfer = document.createElement('input')
      document.body.appendChild(transfer)
      transfer.value = this.http
      transfer.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      transfer.blur()
      document.body.removeChild(transfer)
      this.$Message.success('复制链接成功');
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal{
      top: 0;
  }
}
/deep/ .ivu-modal-header,
/deep/ .ivu-modal-footer  {
  border: none;
  text-align: center;
}
.link {
  display: block;
  font-weight: 400;
  color: blue;
}
</style>